import i18n from "@/i18n";

export const selectSolutionFields = [
    {
        key: "name",
        label: i18n.t("common.name"),
        sortable: true,
        tdClass: "text-left",
        sortDirection: "desc"
    }
];
